import { createFileRoute } from '@tanstack/react-router'
import { ScCaseNotesPage } from '@/features/support-coordination/case-notes'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/case-notes',
)({
  component: ScCaseNotesPage,
})
